import { createTheme } from '@mui/material/styles';

export const Theme = createTheme({
    components: {
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: "7.5px",
                        '& fieldset': {
                            borderColor: "#B7CBD3"
                        }
                    }
                }
            }
        },
        MuiMobileStepper: {
            styleOverrides: {
                positionStatic: {
                    backgroundColor: "inherit",
                    marginBottom: "1rem",
                    justifyContent: "space-evenly"
                },
                dot: {
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #B7CBD3",
                    width: ".5rem",
                    height: ".5rem",
                },
                dotActive: {
                    backgroundColor: "#ED0000",
                    width: ".75rem",
                    height: ".75rem",
                    margin: "-2px 2px"
                },
            }
        },
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    marginTop: 0
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                iconStandard: {
                    color: "#ED0000",
                },
                standard: {
                    marginTop: "0",
                    marginBottom: "0",
                    color: "#ED0000"
                },
                iconOutlined: {
                    color: "#B7CBD3"
                },
                outlined: {
                    fontFamily: 'Roboto',
                    fontWeight: 500,
                    fontSize: "0.75em"
                }
            }
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    fontFamily: "Roboto",
                    fontSize: ".85rem",
                    fontWeight: 400,
                    color: "#B7CBD3",
                    textAlign: "center",
                    width: "100%",
                    marginLeft: "0",
                    marginRight: 0,
                    marginTop: 0,
                    whiteSpace: "break-spaces",
                    lineHeight: 1.25,
                }
            }
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    "&.Mui-selected": {
                        outline: "2px solid #ED0000",
                        backgroundColor: "#FFFFFF !important"
                    }
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    backgroundColor: "#ED00001A",
                    fontSize: ".63em"
                }
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: "10px",
                        '& fieldset': {
                            borderColor: "unset"
                        }
                    }
                },
                inputRoot: {
                    backgroundColor: "#FFFFFF",
                    paddingRight: 0
                },
                paper: {
                    marginTop: 0
                },
                listbox: {
                    maxHeight: "35vh"
                }
            }
        },
        MuiSlider: {
            styleOverrides: {
                markLabel: {
                    fontFamily: "Roboto, sans-serif",
                    fontSize: ".8rem",
                    marginTop: ".8rem"
                },
                root: {
                    height: "1rem",
                    color: "#37464926"
                },

                thumb: {
                    color: "#F7F9FA",
                    height: "2rem",
                    width: "2rem"
                },
                track: {
                    color: "#285AFF1A"
                }
            }
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    minHeight: "65%"
                }
            }
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    boxShadow: "none"
                }
            }
        },
        MuiSnackbar: {
            styleOverrides: {
                root: {
                    borderRadius: "4px",
                    whiteSpace: "pre-line",
                    textAlign: "left",
                }
            }
        },
        MuiSnackbarContent: {
            styleOverrides: {
                root: {
                    color: "#374649",
                    fontFamily: "Roboto, sans-serif",
                    fontWeight: 400,
                }
            }
        },
        MuiDrawer: {
            styleOverrides: {
                paperAnchorBottom: {
                    overflow: "unset",
                    boxShadow: "0px 2px 20px rgba(0, 0, 0, 0.25)",
                    borderRadius: "16px 16px 0px 0px",
                    paddingTop: "2.5rem",
                    paddingBottom: "1rem"
                }
            }
        }
    },
    typography: {
        h4: {
            marginLeft: "1.5rem",
            fontSize: "1.2em",
            fontFamily: "nunito",
            fontWeight: "600",
            letterSpacing: "0",
            color: "#00b2eb"
        },
        h5: {
            fontSize: "1.1rem",
            fontFamily: "nunito",
            fontWeight: "600",
            letterSpacing: "0",
        },
        h6: {
            marginLeft: "1rem",
            fontSize: "1.3rem",
            fontFamily: "nunito",
            fontWeight: "600",
            letterSpacing: "0"
        },
        body1: {
            marginTop: "1.5rem",
            marginBottom: "1.5rem",
            fontSize: "1.2rem",
            fontFamily: "nunito",
            fontWeight: "600",
            letterSpacing: "0"
        },
        body2: {
            fontSize: ".9rem",
            fontFamily: "nunito",
            fontWeight: "600",
            letterSpacing: "0"
        },
        subtitle1: {
            fontSize: ".95rem",
            fontFamily: "Roboto",
            fontWeight: 500,
            letterSpacing: 0,
            marginBottom: ".5rem",
            lineHeight: 1.5
        },
        subtitle2: {
            fontSize: ".72em",
            fontFamily: "Roboto",
            fontWeight: 500,
            letterSpacing: 0,
            color: "#B7CBD3"
        },
        caption: {
            fontSize: ".85rem",
            fontFamily: "Roboto",
            fontWeight: 400,
            letterSpacing: 0,
            marginBottom: ".5rem",
            lineHeight: 1.5
        }
    },
    palette: {
        primary: {
            main: "#374649",
            light: "#00b2eb"
        },
        background: {
            default: "#F7F9FA"
        },
        secondary: {
            main: "#ED0000"
        },
        error: {
            main: "#ED0000"
        },
        info: {
            main: "#B7CBD3"
        }
    }
});